export const EXCERCISE_TYPES = {
  MOEE: "moee",
  FWEE: "fwee",
  SOEE: "soee",
};

/**
 * supported dossier types
 */
export const DOSSIER_TYPES = {
  SYSTEM: "system",
  ZONAL: "zonal",
  STRUCTURE: "structure",
};

export const TASK_REVIEW_NON_EDITABLE_FIELDS = ['mpdTaskReference','maintenanceProgram', 'ompTaskReference'];
export const TASK_REVIEW_DESCRIPTION_FIELDS = ['ompTaskDescription','taskDescription'];
export const HASH_TABLE_WITH_TOTAL = ['EI Risk Rating','OI Risk Rating'];
export const EI_OI_CHART_TITLES = ["EI - Rates","OI - Rates"];

export const EISM_TITLE = "Climate change impact per A/C per year";
export const EISM_DOUGHNUT_TITLE = "Climate change impact breakdown";

export const PINK_FOR_GRAPH = '#e1469c';
export const BLUE_FOR_GRAPH = '#2e9fe0';